// extracted by mini-css-extract-plugin
export var actionButton = "_rs-0";
export var actionMenuContainer = "_rs-i";
export var bubble = "_rs-2";
export var bubbleActionMenu = "_rs-j";
export var bubbleContext = "_rs-6";
export var bubbleItems = "_rs-7";
export var customer = "_rs-3";
export var divider = "_rs-8";
export var fileList = "_rs-9";
export var hiddenComment = "_rs-o";
export var infoAbove = "_rs-a";
export var internal = "_rs-4";
export var lightActionButton = "_rs-1";
export var link = "_rs-b";
export var merchant = "_rs-5";
export var message = "_rs-c";
export var profilePicture = "_rs-e";
export var quillToolbarContainer = "_rs-f";
export var senderDate = "_rs-g";
export var senderDateCustomer = "_rs-h";
export var senderName = "_rs-d";
export var time = "_rs-k";
export var uploadedImage = "_rs-l";
export var username = "_rs-m";
export var xsmall = "_rs-n";